module.exports = __webpack_public_path__ + "static/media/mezie and ola.38b505c6.jpg";